"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var objectFieldTemplateStyles_1 = require("./objectFieldTemplateStyles");
exports.ObjectFieldTemplate = function (props) {
    var styles = objectFieldTemplateStyles_1.default();
    var properties = props.properties;
    var renderObjectFieldTemplate = function () {
        var _a;
        return (_a = properties) === null || _a === void 0 ? void 0 : _a.map(function (field, index) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var fieldUiSchema = (_d = (_c = (_b = (_a = field) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.uiSchema) === null || _d === void 0 ? void 0 : _d['ui:options'];
            var width = typeof ((_e = fieldUiSchema) === null || _e === void 0 ? void 0 : _e.width) === 'string' ? parseInt((_f = fieldUiSchema) === null || _f === void 0 ? void 0 : _f.width, 10) : (_g = fieldUiSchema) === null || _g === void 0 ? void 0 : _g.width;
            var isHidden = !!((_h = fieldUiSchema) === null || _h === void 0 ? void 0 : _h.hide);
            if (isHidden) {
                return null;
            }
            return (<core_1.Grid item key={index} xs={12} sm={width} className={styles.child}>
          {field.content}
        </core_1.Grid>);
        });
    };
    return (<>
      <core_1.Grid container className={styles.root}>
        {renderObjectFieldTemplate()}
      </core_1.Grid>
    </>);
};
exports.default = exports.ObjectFieldTemplate;
